export default __webpack_public_path__ + "static/media/Whats-left_24.e8cb6800.svg";